import React, { PureComponent, Suspense } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

import DrawingWizard from './containers/DrawingWizard';
// const DrawingWizard = lazy(() => import('./containers/DrawingWizard'));


export default class App extends PureComponent {

  render() {
    return (
        <div style={{ height: 'inherit' }} className={'app'}>
          <div style={{ height: 'inherit' }} className={'appContent'}>
            <Suspense fallback={() => null as any}>
                <BrowserRouter>
              <Switch>
                <Route path="/" component={DrawingWizard} />
                <Route component={DrawingWizard} />
              </Switch>
                </BrowserRouter>
            </Suspense>
          </div>
        </div>
    );
  }
}
